import React from "react"
import { useTranslation } from "react-i18next"
import { EloTier, ELO_TIERS } from "../../../../../config/game/ranked"
import "./wiki-leagues.css"

const leagueInfo: {
  tier: EloTier
  color: string
  fallbackElo: number
}[] = [
  { tier: EloTier.MASTER_BALL, color: "#9B59B6", fallbackElo: 2000 },
  { tier: EloTier.ULTRA_BALL, color: "#F1C40F", fallbackElo: 1500 },
  { tier: EloTier.GREAT_BALL, color: "#3498DB", fallbackElo: 1200 },
  { tier: EloTier.POKE_BALL, color: "#E74C3C", fallbackElo: 0 }
]

export default function WikiLeagues() {
  const { t } = useTranslation()

  return (
    <div className="wiki-leagues">
      <h2>{t("leagues_and_ranking")}</h2>
      <p className="wiki-leagues-description">{t("leagues_description")}</p>

      <div className="wiki-leagues-overview">
        {leagueInfo.map(({ tier, color }) => (
          <div key={tier} className="wiki-league-card" style={{ borderColor: color }}>
            <img
              src={`assets/ranks/${tier.toLowerCase().replace("_", "-")}.svg`}
              alt={t(`tier.${tier}`)}
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none"
              }}
            />
            <span className="wiki-league-name" style={{ color }}>
              {t(`tier.${tier}`)} {t("league")}
            </span>
          </div>
        ))}
      </div>

      <h3>{t("leagues_how_it_works")}</h3>

      <div className="wiki-leagues-section">
        <h4>{t("leagues_few_players")}</h4>
        <table className="wiki-leagues-table">
          <thead>
            <tr>
              <th>{t("league")}</th>
              <th>ELO</th>
            </tr>
          </thead>
          <tbody>
            {leagueInfo.map(({ tier, color, fallbackElo }) => (
              <tr key={tier}>
                <td>
                  <span style={{ color }}>{t(`tier.${tier}`)} {t("league")}</span>
                </td>
                <td>
                  {tier === EloTier.POKE_BALL
                    ? t("leagues_everyone_else")
                    : t("leagues_elo_threshold", { elo: fallbackElo })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="wiki-leagues-section">
        <h4>{t("leagues_many_players")}</h4>
        <table className="wiki-leagues-table">
          <thead>
            <tr>
              <th>{t("league")}</th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>
            {leagueInfo.map(({ tier, color }) => {
              const config = ELO_TIERS[tier]
              return (
                <tr key={tier}>
                  <td>
                    <span style={{ color }}>{t(`tier.${tier}`)} {t("league")}</span>
                  </td>
                  <td>
                    {tier === EloTier.POKE_BALL
                      ? t("leagues_everyone_else")
                      : config
                        ? `${t("leagues_top_percent", { percent: config.percentile })} (${t("leagues_top_n_cap", { count: config.topN ?? 0 })})`
                        : ""}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <p className="wiki-leagues-note">{t("leagues_note")}</p>
    </div>
  )
}
